<template>
  <section class="access-denied-view">
    <p class="access-denied-view__text">{{ answer }}</p>
  </section>
</template>

<script>
export default {
  name: 'AccessDeniedView',
  props: {
    answer: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.access-denied-view {
  border: 1px solid $color-border;
  border-radius: $radius-md;
  background: $color-surface-alt;
  padding: $space-4;
}

.access-denied-view__text {
  margin: 0;
  color: $color-text;
}
</style>
